import { getCurrentEmployee } from '@/utils/shared'

export class ModelPayment {
  constructor () {
    this.id = null
    this.invoiceID = null
    this.invoiceNumber = ''
    this.invoiceSourceID = 1
    this.companyID = null
    this.customerPO = ''
    this.invoiceDate = null
    this.invoiceAmount = null
    this.invoiceVATAmount = null
    this.currencyID = null
    this.invoiceDueDate = null
    this.baxCostPerPO = null
    this.orderTypeCommissionID = null

    this.estimatePaymentDate = null
    this.paymentDate = null
    this.paymentAmount = null
    this.methodID = 1
    this.paymentBankID = null
    this.paymentOK = false
    this.paymentRemarks = ''

    this.orderShippingFees = null
    this.salesCommission = null
    this.commRemarks = ''
    this.commInvoice = ''
    this.commInvoiceDate = null
    this.commInvoicePaid = false
    this.invoiceAmountForComm = null
  }
}
export class ModelPaymentLog {
  constructor () {
    const employee = getCurrentEmployee()
    this.id = null
    this.paymentID = null
    this.employeeID = employee.id
    this.entryDate = new Date()
    this.description = ''
    this.isEmployeeEntry = false
    this.isRead = false
  }
}

export const FIELDS_CONFIG = {
  'invoiceID': {
    label: 'invoice',
    type: 'select'
  },
  'invoiceNumber': {
    label: 'invoice-number'
  },
  'invoiceSourceID': {
    label: 'invoice-source',
    type: 'select'
  },
  'companyID': {
    label: 'customer',
    type: 'select'
  },
  'customerPO': {
    label: 'customer-po'
  },
  'invoiceDate': {
    label: 'invoice-date',
    type: 'date'
  },
  'invoiceAmount': {
    label: 'invoice-amount'
  },
  'invoiceVATAmount': {
    label: 'vat-amount'
  },
  'currencyID': {
    label: 'currency',
    type: 'select'
  },
  'invoiceDueDate': {
    label: 'invoice-due-date',
    type: 'date'
  },
  'baxCostPerPO': {
    label: 'bax-cost-per-po'
  },
  'orderTypeCommissionID': {
    label: 'order-type',
    type: 'select'
  },
  'paymentDate': {
    label: 'payment-date',
    type: 'date'
  },
  'paymentAmount': {
    label: 'payment-amount'
  },
  'methodID': {
    label: 'payment-method',
    type: 'select'
  },
  'paymentOK': {
    label: 'payment-ok',
    type: 'checkbox'
  },
  'paymentBankID': {
    label: 'payment-bank',
    type: 'select'
  },
  'paymentRemarks': {
    label: 'payment-remarks'
  },
  'orderShippingFees': {
    label: 'shipping-fees'
  },
  'salesCommission': {
    label: 'sales-commission'
  },
  'commRemarks': {
    label: 'commission-remarks'
  },
  'commInvoice': {
    label: 'commission-invoice'
  },
  'commInvoiceDate': {
    label: 'commission-invoice-date',
    type: 'date'
  },
  'invoiceAmountForComm': {
    label: 'invoice-amount-for-commission'
  },
  'commInvoicePaid': {
    label: 'commission-invoice-paid'
  }
}
